//Node Modules
import { useRecoilValueLoadable } from "recoil";
import { useTranslation } from "react-i18next";

//Pages

//BinaryForge Components
import { ReportPresetsTable } from "./";
import { DatatableSkeleton } from "../../helpers/skeleton";
import { Note } from "../../helpers";

//3rd Party Components

//Atoms
import { reportPresetsSelector } from "../../../atoms/report";

//Helpers

//Other

const ReportPresetsLoader = () => {
	//Recoil
	const { t } = useTranslation();
	const { state, contents } = useRecoilValueLoadable(reportPresetsSelector);

	switch (state) {
		case "hasError":
			return (
				<Note
					messageKey={`Error: ${contents.message ? contents.message : contents}`}
					icon="pi-exclamation-circle fontColour-error"
				/>
			);
		case "loading":
			return <DatatableSkeleton columns={[t("report.preset.table.name")]} />;
		case "hasValue":
			return <ReportPresetsTable reportPresetsData={contents} />;
		default:
			return null;
	}
};

export default ReportPresetsLoader;
